import { ICountry } from '../interface/dataInterface';

export const checkStateRequirement = (
  country: string,
  countryCodes: string[],
): boolean => {
  if (countryCodes.includes(country)) {
    return true;
  }
  return false;
};

export const getStatesForCountry = (
  countryList: ICountry[],
  countryCode: string,
) => countryList?.find((country: ICountry) => country?.code === countryCode);
